
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/itsm-request-management",
      function () {
        return require("private-next-pages/solutions/itsm-request-management/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/itsm-request-management"])
      });
    }
  